(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('PromoCodeDetailController', PromoCodeDetailController);

    PromoCodeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PromoCode'];

    function PromoCodeDetailController($scope, $rootScope, $stateParams, previousState, entity, PromoCode) {
        var vm = this;

        vm.promoCode = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('liverunApp:promoCodeUpdate', function(event, result) {
            vm.promoCode = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
